import { render, staticRenderFns } from "./TotkQuiz.vue?vue&type=template&id=10c976de&"
import script from "./TotkQuiz.vue?vue&type=script&lang=js&"
export * from "./TotkQuiz.vue?vue&type=script&lang=js&"
import style0 from "../styles/quiz.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports